import { Fragment, useEffect, useState } from "react"
import classnames from "classnames"
import { useOktaAuth } from "@okta/okta-react"
import PropTypes from "prop-types"
import { useLocation, useHistory } from "react-router-dom"
import { connect } from "react-redux"
import ErrorBoundary from "../ErrorBoundary"
import Navbar from "../Navbar/Navbar"
import { SideNavbar } from "../SideNavbar"
import Spinner from "../Spinner/spinner"
import logo from "../../assets/images/wabtec_logo.svg"
import { labels } from "../../constants/labels"
import { NavigationNavItmes } from "../../constants/nav-consts/nav-consts"
import AlertNotification from "../AlertNotification"
import * as visiblityActions from "../../redux/visibility/actions"
import * as notificationActions from "../../redux/notification/actions"
import * as emailNotificationActions from "../../redux/emailNotifications/actions"
import * as resequenceActions from "../../redux/resequence/actions"
import * as userProfileActions from "../../redux/userProfile/actions"
import { checkUserPermission } from "../../constants/utils"

import styles from "./Layout.module.scss"
import FooterSection from "../../components/Footer"

const { VITE_APP_EBOL, VITE_APP_ENHANCED_VISIBILITY } = import.meta.env
const Layout = (props) => {
    const [showNavbar, setNavbar] = useState(false)
    let location = useLocation()
    let history = useHistory()

    const {
        userProfileData,
        accesRights,
        getEbolToken,
        ebolToken,
        ebolTokenResponse,
        showNotification,
        emailSavedSuccessfully,
        resetEmailnotificationSave,
        resequenceDoneSuccessfully,
        resequenceFailed,
        resequenceReset,
        ebolWOAccess,
        showEnhancedVisibilityMenu,
        enhancedVisibilityMenu,
    } = props
    const { authState } = useOktaAuth()
    const [isEbolRequested, setEbolRequest] = useState(0)

    const { isEnhancedVisibilityRedirection } = checkUserPermission(accesRights)

    const { children, open, show, message, alertType } = props

    if (enhancedVisibilityMenu) {
        window.open(`${VITE_APP_ENHANCED_VISIBILITY}`, "_blank")
    }
    if (
        ebolTokenResponse !== undefined &&
        ebolTokenResponse === 500 &&
        isEbolRequested === 1
    ) {
        showNotification({
            show: true,
            message: labels.visibilityLbl.ebolFailureMessage,
            alertType: "error",
        })
        setEbolRequest(0)
        setTimeout(function () {
            showNotification({
                show: false,
            })
        }, 4000)
    } else if (!ebolWOAccess && ebolToken && isEbolRequested === 1) {
        window.open(`${VITE_APP_EBOL}/?ST=${ebolToken}`, "_blank")
        setEbolRequest(0)
    }

    useEffect(() => {
        if (
            authState === null &&
            location.pathname !== "/callback" &&
            (location.pathname !== "/" || location.pathname !== "")
        ) {
            history.push("/")
        }
    }, [location, history, authState])

    if (emailSavedSuccessfully) {
        showNotification({
            show: true,
            message: `${labels.common.savedSuccessfully}`,
            alertType: "success",
        })

        setTimeout(function () {
            showNotification({
                show: false,
            })
            resetEmailnotificationSave()
        }, 1000)
    }

    if (resequenceDoneSuccessfully || resequenceFailed) {
        showNotification({
            show: true,
            message: resequenceDoneSuccessfully
                ? labels.visibilityLbl.resequenceDoneMsg
                : labels.visibilityLbl.resequenceFailedMsg,
            alertType: resequenceDoneSuccessfully ? "success" : "error",
        })

        setTimeout(function () {
            resequenceReset()
            showNotification({
                show: false,
            })
        }, 3000)
    }
    return (
        <div
            className={classnames(
                styles.layoutRoot,
                Object.keys(accesRights).length &&
                    !isEnhancedVisibilityRedirection
                    ? styles.showLayout
                    : styles.hideLayout
            )}
            data-test="app-layout"
        >
            {authState && authState.isAuthenticated && (
                <Fragment>
                    <SideNavbar
                        showNavbar={showNavbar}
                        toggleNavbar={setNavbar}
                        navItems={NavigationNavItmes}
                        accesRights={accesRights}
                        getEbolToken={getEbolToken}
                        setEbolRequest={setEbolRequest}
                        showEnhancedVisibilityMenu={showEnhancedVisibilityMenu}
                        ebolWOAccess={ebolWOAccess}
                    />
                    <Navbar
                        logo={logo}
                        projectName="RVP"
                        userProfileData={userProfileData}
                        accesRights={accesRights}
                        showNotification={showNotification}
                        showNavbar={showNavbar}
                        toggleNavbar={setNavbar}
                    />
                    <AlertNotification
                        inputLabel={message}
                        autoCloseTime={6000}
                        alertType={alertType}
                        showHide={show}
                        onClose={() => {
                            showNotification({
                                show: false,
                            })
                        }}
                    />
                    <FooterSection />
                </Fragment>
            )}

            <Spinner open={open} />
            <ErrorBoundary>{children}</ErrorBoundary>
        </div>
    )
}

Layout.propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    alertType: PropTypes.string.isRequired,
    getEbolToken: PropTypes.func.isRequired,
}
function mapStateToProps(state) {
    return {
        open: state.loader.display,
        show: state.notification.show,
        message: state.notification.message,
        alertType: state.notification.alertType,
        userProfileData: state.userProfile.userProfile,
        accesRights: state.userProfile.accesRights,
        ebolToken: state.visibility.ebolToken,
        ebolTokenResponse: state.visibility.ebolResponse,
        emailSavedSuccessfully: state.emailNotifications.emailSavedSuccessfully,
        resequenceDoneSuccessfully: state.resequence.success,
        resequenceFailed: state.resequence.failure,
        ebolWOAccess: state.userProfile.ebolWOAccess,
        enhancedVisibilityMenu: state.userProfile.enhancedVisibilityMenu,
    }
}

const mapDispatchToProps = {
    getEbolToken: visiblityActions.getEbolToken,
    showNotification: notificationActions.showNotification,
    resetEmailnotificationSave:
        emailNotificationActions.resetEmailnotificationSave,
    resequenceReset: resequenceActions.resequenceReset,
    showEnhancedVisibilityMenu: userProfileActions.showEnhancedVisibilityMenu,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
